// 关于我们  隐私协议
import { get } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
const { ad } = apiList

export default axios => ({
  getAd: (params = {}) => get(axios, `${ad}/ad/window`, params) // 广告
})
